<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Адрес электронной почты
        .form-elem__main
          .input {{email}}
          .form-elem__description На этот адрес будут приходить последние новости и уведомления о статусе вашей заявки. Вы можете изменить его в настройках аккаунта.
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Телефон ребенка
        .form-elem__main
          .input {{localPhone}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title ФИО родителя
        .form-elem__main
          .input {{parentsName}}
    .form__elem(
      v-if="parentsPhone"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title Телефон родителей
        .form-elem__main
          .input {{localParentsPhone}}


</template>

<script>
export default {
  name: "operator-form-contacts",
  props: {
    email: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    parentsPhone: {
      type: String,
      default: "",
    },
    parentsName: {
      type: String,
      default: "",
    },
  },
  computed: {
    localPhone() {
      return this.calcPhone(this.phone);
    },
    localParentsPhone() {
      return this.calcPhone(this.parentsPhone);
    },
  },
  methods: {
    calcPhone(phone) {
      let block_1 = phone[0];
      let block_2 = phone.slice(1, 4);
      let block_3 = phone.slice(4, 7);
      let block_4 = phone.slice(7, 9);
      let block_5 = phone.slice(9, 11);
      return (
        "+" +
        block_1 +
        "(" +
        block_2 +
        ")-" +
        block_3 +
        "-" +
        block_4 +
        "-" +
        block_5
      );
    },
  },
};
</script>
